module.exports = __webpack_public_path__ + "img/GAME_BUNGEOPPANG.b55c6db5.jpg";